import React from 'react';
import { trackClick } from 'utility/analytics';
import { Button } from 'theme/Button';
import { Link } from 'react-router-dom';
import { Row, Col } from '@zendeskgarden/react-grid';
import { MD, SM } from '@zendeskgarden/react-typography';
import { Wrapper } from './ProductStyles.styles.js';

import {
  AttributeRow,
  Attribute,
  AttributeWrapper,
} from 'routes/Products/components/ProductsHero/ProductsHero.styles.js';

const Contentproduct = ({ product = {} } = {}) => {
  function onClickViewProduct(product) {
    trackClick('viewListing', 'View Listing', 'ContentPage', {
      id: product.id,
      title: product.title,
    });
    window.open(`/p/${product.slug}/${product.id}`);
  }

  return (
    <Wrapper>
      <Row wrap="wrap">
        <Col>
          <div>
            <Link target="_blank" to={`/p/${product.slug}/${product.id}`}>
              <MD className="bold" as="h3">
                {product.name}
              </MD>
            </Link>
            <div>
              <HeroAttributes
                description={product.description}
                attributes={product.criteria}
              />
            </div>

            <Button
              style={{ display: 'block', marginTop: '0px' }}
              primary
              onClick={() => onClickViewProduct(product)}
            >
              View Product
            </Button>
          </div>
        </Col>
      </Row>
    </Wrapper>
  );
};

const HeroAttributes = ({ description, attributes } = {}) => {
  return (
    <AttributeRow>
      <AttributeWrapper size="auto">
        <Attribute>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            noMargin
            as="h3"
            bold
          >
            OD
          </SM>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            paddingTopSm
            noMargin
            as="h3"
          >
            {attributes.od + '"' || ''}
          </SM>
        </Attribute>
      </AttributeWrapper>
      <AttributeWrapper size="auto">
        <Attribute>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            noMargin
            as="h3"
            bold
          >
            #/FT
          </SM>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            paddingTopSm
            noMargin
            as="h3"
          >
            {attributes.weight_per_foot + ' LB' || ''}
          </SM>
        </Attribute>
      </AttributeWrapper>
      <AttributeWrapper size="auto">
        <Attribute>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            noMargin
            as="h3"
            bold
          >
            Wall
          </SM>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            paddingTopSm
            noMargin
            as="h3"
          >
            {attributes.wall + '"' || ''}
          </SM>
        </Attribute>
      </AttributeWrapper>
      <AttributeWrapper size="auto">
        <Attribute>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            noMargin
            as="h3"
            bold
          >
            ID
          </SM>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            paddingTopSm
            noMargin
            as="h3"
          >
            {attributes.inside_diameter + '"' || ''}
          </SM>
        </Attribute>
      </AttributeWrapper>
      <AttributeWrapper size="auto">
        <Attribute>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            noMargin
            as="h3"
            bold
          >
            Min Yield
          </SM>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            paddingTopSm
            noMargin
            as="h3"
          >
            {attributes.min_yield + ' KSI' || ''}
          </SM>
        </Attribute>
      </AttributeWrapper>
      <AttributeWrapper size="auto">
        <Attribute>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            noMargin
            as="h3"
            bold
          >
            Drift
          </SM>
          <SM
            style={{ lineHeight: '22px', fontSize: '14px' }}
            paddingTopSm
            noMargin
            as="h3"
          >
            {attributes.drift + '"' || ''}
          </SM>
        </Attribute>
      </AttributeWrapper>
    </AttributeRow>
  );
};

export default Contentproduct;
